import { Reveal } from "./Reveal";
import { Star } from "./Logo";
import { useLang } from "@/i18n/LanguageContext";

export default function Testimonials({ mode = "b2c" }) {
  const { t } = useLang();
  const items = mode === "b2b" ? t.testimonials.items.slice(0, 3) : t.testimonials.items.slice(3);
  const title = mode === "b2b" ? t.b2bPage.voicesTitle : t.testimonials.title;
  return (
    <section id="stimmen" className="mx-auto max-w-7xl px-5 sm:px-8 py-24 sm:py-36" data-testid="testimonials-section">
      <Reveal className="text-center">
        <p className="flex items-center justify-center gap-2 text-xs uppercase font-medium" style={{ color: "var(--camel)", letterSpacing: "0.16em" }}>
          <Star size={11} /> {t.testimonials.kicker}
        </p>
        <h2 className="mx-auto mt-5 max-w-2xl font-serif-display text-4xl sm:text-5xl font-semibold leading-tight" data-testid="testimonials-title">
          {title}
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {items.map((item, i) => (
          <Reveal
            key={i}
            delay={(i % 3) * 0.1}
            className="group flex flex-col rounded-3xl border p-8 transition-shadow duration-500 hover:shadow-[0_24px_48px_-24px_rgba(212,175,55,0.35)]"
            style={{ background: i % 2 === 0 ? "var(--surface-secondary)" : "var(--surface)", borderColor: "var(--line)" }}
            data-testid={`testimonial-card-${i + 1}`}
          >
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, s) => (
                <Star key={s} size={13} className="transition-transform duration-300 group-hover:scale-110" />
              ))}
            </div>
            <p className="mt-5 flex-1 font-serif-display text-lg sm:text-xl italic leading-relaxed">
              „{item.q}“
            </p>
            <div className="mt-6 border-t pt-4" style={{ borderColor: "var(--line)" }}>
              <p className="text-sm font-bold">{item.name}</p>
              <p className="mt-0.5 text-xs" style={{ color: "var(--muted-warm)" }}>{item.role}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
